import { render } from "./InvoiceDealDetailsTable.vue?vue&type=template&id=560132a6&ts=true"
import script from "./InvoiceDealDetailsTable.vue?vue&type=script&lang=ts"
export * from "./InvoiceDealDetailsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__